export default {
    clearLocalStorage: (state) => {
        state.expiration = null
        state.modulos = null
        state.sidebar = null
        state.token = null
        state.usuario = null
    },
    createNotification(state, params) {
        params.visible = true
        state.notification = params
    },
    setExpiration: (state, expiration) => state.expiration = expiration,
    setLoading: (state, local) => state.loading.push(local),
    setModulos: (state, modulos) => state.modulos = modulos,
    setNotification: (state, params) => state.notification = Object.assign({}, state.notification, params),
    setSidebar: (state, value) => state.sidebar = value,
    setToken: (state, token) => state.token = token,
    setUsuario: (state, usuario) => state.usuario = usuario,
    unsetLoading: (state, local) => state.loading.splice(local, 1),
}